import React, { useEffect, useState } from "react";
import {
  Container,
  Table,
  Button,
  Form,
  Row,
  Col,
  Modal,
} from "react-bootstrap";
import axios from "axios";
import { PDFDownloadLink } from "@react-pdf/renderer";
import BalanceSheetPDF from "./BalanceSheetPDF";
import API_DOMAIN from "../../config/config";
import "./BalanceSheet.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_URL = `${API_DOMAIN}/balance.php`;

const BalanceSheet = () => {
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [initialBalance, setInitialBalance] = useState(0);
  const [balance, setBalance] = useState(0);
  const [entries, setEntries] = useState([]);
  const [filteredEntries, setFilteredEntries] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format

  console.log(filteredEntries);
  // Date Filter States
  const [totalPages, setTotalPages] = useState(1);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [expandedDate, setExpandedDate] = useState(null);
  const currentMonth = String(new Date().getMonth() + 1).padStart(2, "0");
  const currentYear = String(new Date().getFullYear());

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [displayLimit, setDisplayLimit] = useState(50);

  const months = [
    { val: "01", label: "January" },
    { val: "02", label: "February" },
    { val: "03", label: "March" },
    { val: "04", label: "April" },
    { val: "05", label: "May" },
    { val: "06", label: "June" },
    { val: "07", label: "July" },
    { val: "08", label: "August" },
    { val: "09", label: "September" },
    { val: "10", label: "October" },
    { val: "11", label: "November" },
    { val: "12", label: "December" },
  ];

  const years = Array.from({ length: 5 }, (_, i) =>
    String(new Date().getFullYear() - i),
  );
  const toggleDate = (date) => {
    console.log(date);
    setExpandedDate((prev) => (prev === date ? null : date));
  };

  useEffect(() => {
    fetchBalance();
    fetchEntries();
  }, []);

  const fetchBalance = async () => {
    try {
      const response = await axios.post(API_URL, { action: "get_balance" });
      if (response.data.head.code === 200) {
        setBalance(response.data.body.balance);
      }
    } catch (error) {
      console.error("Error fetching balance:", error);
    }
  };

  const fetchEntries = async (pageNumber = 1) => {
    console.log("pageNumber", pageNumber);
    try {
      const response = await axios.post(API_URL, {
        action: "list_transactions",
        month: selectedMonth,
        year: selectedYear,
        page: pageNumber, // Hits the server with the specific page
      });

      if (response.data.head.code === 200) {
        setEntries(response.data.body.transactions || []);
        setFilteredEntries(response.data.body.transactions || []);
        setInitialBalance(response.data.body.initial_balance || 0);
        setTotalPages(response.data.body.total_pages || 1); // Set total pages from server
        setPage(pageNumber); // Update current page state
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      toast.error("Failed to load transactions");
    }
  };

  // Add Balance Function
  const addBalance = async () => {
    if (!description || !amount) {
      alert("Please enter description and amount");
      return;
    }

    try {
      const response = await axios.post(API_URL, {
        action: "add_transaction",
        description: description,
        amount: parseFloat(amount),
        type: "varavu", // Adding balance (Income)
      });

      if (response.data.head.code === 200) {
        toast.success("Transaction added successfully");
        setShowModal(false);
        setDescription("");
        setAmount("");
        fetchBalance();
        fetchEntries();
      } else {
        alert("Failed to add transaction");
      }
    } catch (error) {
      console.error("Error adding transaction:", error);
    }
  };

  const generateDaybookSummary = (
    allEntries,
    startDate,
    endDate,
    startingPoint = 0,
  ) => {
    if (!allEntries || allEntries.length === 0) {
      // Even if no entries, show the carried forward balance
      return [
        {
          date: startDate,
          opening: startingPoint,
          varavu: 0,
          patru: 0,
          closing: startingPoint,
        },
      ];
    }

    const sortedEntries = [...allEntries].sort(
      (a, b) => new Date(a.transaction_date) - new Date(b.transaction_date),
    );

    const summaryMap = new Map();
    sortedEntries.forEach((entry) => {
      const date = entry.transaction_date.slice(0, 10);
      if (!summaryMap.has(date)) {
        summaryMap.set(date, { date, varavu: 0, patru: 0 });
      }
      const summary = summaryMap.get(date);
      const amount = parseFloat(entry.amount || 0);
      if (entry.type === "varavu") summary.varavu += amount;
      else if (entry.type === "patru") summary.patru += amount;
    });

    // Use the initial balance passed from the API
    let previousClosing = startingPoint;

    return Array.from(summaryMap.entries())
      .sort(([a], [b]) => new Date(a) - new Date(b))
      .map(([date, summary]) => {
        const opening = previousClosing;
        const closing = opening + summary.varavu - summary.patru;
        previousClosing = closing;

        return {
          date,
          opening,
          varavu: summary.varavu,
          patru: summary.patru,
          closing,
        };
      });
  };
  // --- Updated Summary Logic ---
  let summaryData = [];

  if (Array.isArray(filteredEntries) && filteredEntries.length > 0) {
    summaryData = generateDaybookSummary(
      filteredEntries,
      startDate,
      endDate,
      initialBalance,
    );
  } else {
    summaryData = [];
  }
  // --- End of Update ---

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <Container className="balance-sheet-container">
      <h5 className="mt-5 mb-3 text-center">📘 Day-wise Summary</h5>

      {/* Balance Display */}
      <div className="balance-container text-center mb-4">
        <h5>Current Balance: ₹{balance}</h5>
      </div>

      {/* Add Balance Button */}
      {/* <Button className="custom-btn mb-4" onClick={() => setShowModal(true)}>
        Add Balance
      </Button> */}

      {/* Add Balance Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Balance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button className="close-btn " onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button className="custom-btn" onClick={addBalance}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Date Filter Section */}
      <Row className="mb-3">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Select Month</Form.Label>
            <Form.Select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              {months.map((m) => (
                <option key={m.val} value={m.val}>
                  {m.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Select Year</Form.Label>
            <Form.Select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4} className="d-flex align-items-end">
          <Button className="custom-btn" onClick={() => fetchEntries(1)}>
            Apply Filter
          </Button>
          <Button
            className="custom-btn ms-2"
            onClick={() => {
              setSelectedMonth(currentMonth);
              setSelectedYear(currentYear);
              fetchEntries(1);
            }}
          >
            Undo Filter
          </Button>
        </Col>
      </Row>

      {/* Open/Close Balance Toggle with Advanced Design */}
      <Row className="mb-3 d-flex align-items-center justify-content-between">
        {/* Download Button */}
        <Col md={6}>
          <PDFDownloadLink
            document={
              <BalanceSheetPDF
                allEntries={entries}
                startDate={null} // Pass null so PDF auto-calculates range from data
                endDate={null} // Pass null so PDF auto-calculates range from data
                balance={balance}
              />
            }
            fileName="BalanceSheet.pdf"
          >
            {({ loading }) =>
              loading ? (
                <Button className="custom-btn" disabled>
                  Generating PDF...
                </Button>
              ) : (
                <Button className="custom-btn">Download PDF</Button>
              )
            }
          </PDFDownloadLink>
        </Col>
      </Row>

      <Table striped bordered hover responsive className="custom-table mt-3">
        <thead className="table-header">
          <tr>
            <th className="table-header1">Date</th>
            <th className="table-header1">Day Opening Balance</th>
            <th className="table-header1">Total Credit (Varavu)</th>
            <th className="table-header1">Total Debit (Patru)</th>
            <th className="table-header1">Day Closing Balance</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(summaryData) && summaryData.length > 0 ? (
            summaryData.map((row, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td>{new Date(row.date).toLocaleDateString("en-GB")}</td>

                  <td>₹{row.opening.toLocaleString()}</td>
                  <td>₹{row.varavu.toLocaleString()}</td>
                  <td>₹{row.patru.toLocaleString()}</td>
                  <td>₹{row.closing.toLocaleString()}</td>
                  <td>
                    <button onClick={() => toggleDate(row.date)}>
                      {expandedDate === row.date ? "Hide" : "View"} Details
                    </button>
                  </td>
                </tr>

                {/* ✅ Conditional breakdown row */}
                {expandedDate === row.date &&
                  (() => {
                    // 1. Get all entries for this date
                    const entriesForDate = filteredEntries.filter(
                      (entry) =>
                        entry.transaction_date.slice(0, 10) === row.date,
                    );

                    // 2. Define how many rows to show initially (e.g., 50)
                    // We use a local variable here to prevent freezing

                    const totalVaravu = entriesForDate
                      .filter((entry) => entry.type === "varavu")
                      .reduce(
                        (sum, entry) => sum + parseFloat(entry.amount),
                        0,
                      );

                    const totalPatru = entriesForDate
                      .filter((entry) => entry.type === "patru")
                      .reduce(
                        (sum, entry) => sum + parseFloat(entry.amount),
                        0,
                      );

                    // 3. Slice the array to only show the limit
                    const visibleEntries = entriesForDate.slice(
                      0,
                      displayLimit,
                    );

                    return (
                      <tr>
                        <td colSpan={6}>
                          <div
                            style={{
                              maxHeight: "450px",
                              overflowY: "auto",
                              border: "1px solid #dee2e6",
                              borderRadius: "4px",
                              padding: "10px",
                              backgroundColor: "#f8f9fa",
                            }}
                          >
                            <Table
                              striped
                              bordered
                              hover
                              responsive
                              className="custom-table mt-3"
                            >
                              <thead className="table-header">
                                <tr>
                                  <th className="table-header1">Date</th>
                                  <th className="table-header1">Loan No</th>
                                  <th className="table-header1">Description</th>
                                  <th className="table-header1">
                                    Credit (Varavu)
                                  </th>
                                  <th className="table-header1">
                                    Debit (Patru)
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {/* 🚀 Render only the visible entries */}
                                {visibleEntries.map((entry, idx) => (
                                  <tr key={idx}>
                                    <td>
                                      {formatDate(entry.transaction_date)}
                                    </td>
                                    <td>{entry.receipt_no || "-"}</td>
                                    <td>
                                      {entry.description}{" "}
                                      {entry.type === "patru"
                                        ? "(பற்று)"
                                        : "(வரவு)"}
                                    </td>
                                    <td>
                                      {entry.type === "varavu"
                                        ? `₹${parseFloat(entry.amount).toLocaleString()}`
                                        : "-"}
                                    </td>
                                    <td>
                                      {entry.type === "patru"
                                        ? `₹${parseFloat(entry.amount).toLocaleString()}`
                                        : "-"}
                                    </td>
                                  </tr>
                                ))}

                                {/* 🚀 LOAD MORE BUTTON: Appears if there is more data */}
                                {displayLimit < entriesForDate.length && (
                                  <tr>
                                    <td colSpan={5} className="text-center p-3">
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setDisplayLimit(displayLimit + 100);
                                        }}
                                      >
                                        Load More (+100 of{" "}
                                        {entriesForDate.length - displayLimit}{" "}
                                        remaining)
                                      </Button>
                                    </td>
                                  </tr>
                                )}

                                <tr className="font-weight-bold bg-light">
                                  <td colSpan={3} className="text-end">
                                    <strong>Total Credit Debit</strong>
                                  </td>
                                  <td>
                                    <strong>
                                      ₹{totalVaravu.toLocaleString()}
                                    </strong>
                                  </td>
                                  <td>
                                    <strong>
                                      ₹{totalPatru.toLocaleString()}
                                    </strong>
                                  </td>
                                </tr>
                                <tr className="font-weight-bold bg-light">
                                  <td colSpan={3} className="text-end">
                                    <strong>Day Opening Balance</strong>
                                  </td>
                                  <td>
                                    <strong>
                                      ₹{row.opening.toLocaleString()}
                                    </strong>
                                  </td>
                                </tr>
                                <tr className="font-weight-bold bg-light">
                                  <td colSpan={3} className="text-end">
                                    <strong>Day Closing Balance</strong>
                                  </td>
                                  <td>
                                    <strong>
                                      ₹{row.closing.toLocaleString()}
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </td>
                      </tr>
                    );
                  })()}
              </React.Fragment>
            ))
          ) : (
            /* 🚀 THIS IS THE NEW "NO RECORD FOUND" ROW */
            <tr>
              <td colSpan={6} className="text-center p-5">
                <div className="no-record-container">
                  <h6 className="text-muted">
                    No records found for the selected period.
                  </h6>
                  {/* <p className="text-secondary">Try adjusting your date filters or month selection.</p> */}
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <div className="d-flex justify-content-center mt-4 mb-5">
        <Button
          disabled={page === 1}
          onClick={() => fetchEntries(page - 1)} // Call API for previous page
          className="me-2 custom-btn"
        >
          Previous
        </Button>

        <span className="align-self-center mx-3 font-weight-bold">
          Page {page} of {totalPages}
        </span>

        <Button
          className="custom-btn"
          disabled={page >= totalPages}
          onClick={() => fetchEntries(page + 1)} // Call API for next page
        >
          Next
        </Button>
      </div>

      <ToastContainer />
    </Container>
  );
};

export default BalanceSheet;
